import { action } from 'easy-peasy';
import { IActionSetSystemAlertUpdates } from '../types';

const setSystemAlertUpdates: IActionSetSystemAlertUpdates = action((state, alertUpdates) => {
  state.systemAlertUpdates = alertUpdates;
});

export default setSystemAlertUpdates;
